import InputWithLengthLimit from './input_with_length_limit/input_with_length_limit_unpoly_redesign'

up.compiler('.js-input_with_length_limit_redesign', function (element) {
  new InputWithLengthLimit(element)
})
